module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"omitted_count":"외 {0}개 상품","write_review":"리뷰 작성하러 가기"}}')
  delete Component.options._Ctor
}
